module.exports = __webpack_public_path__ + "img/tobeupdated.0e7e2dbc.png";